import * as React from "react";
import Tooltip from "@material-ui/core/Tooltip";

const styles = require("./overlayTooltip.scss");

type Placement =
  | "bottom-end"
  | "bottom-start"
  | "bottom"
  | "left-end"
  | "left-start"
  | "left"
  | "right-end"
  | "right-start"
  | "right"
  | "top-end"
  | "top-start"
  | "top";

interface IProps
  extends React.PropsWithChildren<{
    position: Placement;
    tooltipContent: React.ReactNode;
    disableFocusListener?: boolean;
    disableHoverListener?: boolean;
    disableTouchListener?: boolean;
    open?: boolean;
    onOpen?: (event: React.ChangeEvent<{}>) => void;
    onClose?: (event: React.ChangeEvent<{}>) => void;
  }> {}

const OverlayTooltip: React.FC<IProps> = ({
  position,
  tooltipContent,
  children,
  ...restTooltipProps
}) => {
  return (
    <Tooltip
      interactive={true}
      leaveDelay={50}
      placement={position}
      classes={{
        tooltip: styles.muiTooltip,
        tooltipPlacementTop: styles.positionTop,
        tooltipPlacementBottom: styles.positionBottom,
        tooltipPlacementRight: styles.positionRight,
        tooltipPlacementLeft: styles.positionLeft,
      }}
      title={<div className={styles.paper}>{tooltipContent}</div>}
      {...restTooltipProps}
    >
      <div className={styles.childContainer}>{children}</div>
    </Tooltip>
  );
};

export default OverlayTooltip;
